module.exports = __webpack_public_path__ + "static/img/上交所行情授权.f8ce623.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/上交所行情授权.jpg
// module id = 5Ud8
// module chunks = 1